const LETTER_A_DEC = 65;

const convertIndexToLetter = (index) => String.fromCharCode(LETTER_A_DEC + index);

module.exports = {
  convertIndexToLetter,
};
